import React from 'react'
import Main from './pages/Main/Main'
function App() { return <Main /> }
export default App
